import { useMemo, useCallback, SetStateAction, Dispatch, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function parsePage(sp: URLSearchParams): number {
    const val = parseInt(sp.get("page") || "", 10);
    return !isNaN(val) && val > 0 ? val : 1;
}

export default function usePageParam(): {
    page: number;
    setPage: Dispatch<SetStateAction<number>>;
} {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = useMemo(() => parsePage(searchParams), [searchParams]);

    useEffect(() => {
        if (page === 1 && searchParams.get("page") === "1") {
            const current = Object.fromEntries(
                searchParams.entries()
            ) as Record<string, string>;

            delete current.page;
            setSearchParams(current, { replace: true });
        }
    }, [page, searchParams, setSearchParams]);


    const setPage = useCallback<Dispatch<SetStateAction<number>>>((value) => {

        const nextPage = typeof value === "function" ? (value as (prev: number) => number)(page) : value;

        const current = Object.fromEntries(searchParams.entries()) as Record<string, string>;

        if (nextPage <= 1) {
            delete current.page;
            setSearchParams(current)
        } else {
            setSearchParams({
                ...current,
                page: String(nextPage),
            });

        }
    }, [searchParams, setSearchParams, page])
    return { page, setPage };
}
